import {
  SET_SELECTED_ACADEMIC_YEAR_GLOBALLY,
  SET_COURSE_IS_EXPANDED,
  SET_LEVEL_IS_EXPANDED,
  CLEAR_EXPANDED_LEVELS
} from '../actions/mycourses'

const initialState = {
  selectedAcademicYearGlobally: null,
  expandedCourses: [],
  expandedLevels: []
}

const updateExpandedList = (expanded, payload) => {
  let newList
  if (payload.isExpanded) {
    newList = [...expanded]
    if (!newList.includes(payload.id)) newList.push(payload.id)
  } else {
    newList = expanded.filter(i => i != payload.id)
  }
  return newList
}

export function mycourses(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_ACADEMIC_YEAR_GLOBALLY:
      return Object.assign({}, state, {
        selectedAcademicYearGlobally: action.payload.academicYear
      })
    case SET_COURSE_IS_EXPANDED:
      const ec = updateExpandedList(state.expandedCourses, action.payload)
      return {
        ...state,
        expandedCourses: ec
      }
    case SET_LEVEL_IS_EXPANDED:
      const el = updateExpandedList(state.expandedLevels, action.payload)
      return {
        ...state,
        expandedLevels: el
      }
    case CLEAR_EXPANDED_LEVELS:
      return {
        ...state,
        expandedLevels: []
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/mycourses.js